import { System } from '@ecs/System';
import { Position } from '@components/Position';
import { Velocity } from '@components/Velocity';
import { SniperAI } from '@components/SniperAI';
import { Tag } from '@components/Tag';
import { RailgunWeapon } from '@components/RailgunWeapon';

export class SniperAISystem extends System {
  update(_deltaTime: number): void {
    const snipers = this.getEntitiesWithComponents(Position, Velocity, SniperAI, Tag);
    const players = this.getEntitiesWithComponents(Position, Tag).filter(
      e => e.getComponent(Tag)!.value === 'player'
    );
    
    if (players.length === 0) return;

    for (const sniper of snipers) {
      const tag = sniper.getComponent(Tag)!;
      if (tag.value !== 'enemy') continue;

      const position = sniper.getComponent(Position)!;
      const velocity = sniper.getComponent(Velocity)!;
      const ai = sniper.getComponent(SniperAI)!;
      const railgun = sniper.getComponent(RailgunWeapon);

      // Check if railgun is charging - if so, don't move
      if (railgun && railgun.isCharging) {
        velocity.speed = 0;
        continue; // Skip all movement logic while charging
      }

      // Find nearest player
      let nearestPlayer = null;
      let minDistance = Infinity;

      for (const player of players) {
        const playerPos = player.getComponent(Position)!;
        const dx = playerPos.x - position.x;
        const dy = playerPos.y - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance < minDistance) {
          minDistance = distance;
          nearestPlayer = playerPos;
        }
      }

      if (nearestPlayer) {
        const dx = nearestPlayer.x - position.x;
        const dy = nearestPlayer.y - position.y;
        const targetAngle = Math.atan2(dy, dx);

        // Positioning logic
        if (minDistance < ai.minRange) {
          // Too close - retreat
          const retreatAngle = Math.atan2(-dy, -dx);
          velocity.speed = velocity.maxSpeed * 1.2;
          velocity.angle = retreatAngle;
          ai.isInPosition = false;
        } else if (minDistance > ai.maxRange) {
          // Too far - approach
          velocity.speed = velocity.maxSpeed;
          velocity.angle = targetAngle;
          ai.isInPosition = false;
        } else {
          // Perfect range - stop and shoot
          velocity.speed = 0;
          velocity.angle = targetAngle; // Face target
          ai.isInPosition = true;
        }
      } else {
        // No target - patrol
        velocity.speed = velocity.maxSpeed * 0.3;
        ai.isInPosition = false;
      }
    }
  }
}